export default __webpack_public_path__ + "resources/icons/d222-05f4.png";